// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Tooltip_wrapper__x25Oh","top":"Tooltip_top__2vUkJ","bottom":"Tooltip_bottom__2LQbU","hidden":"Tooltip_hidden__13-lO"};